<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="随货文件"
      class="customer-edit"
      width="80%"
      top="5vh"
      @close="close">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="customerDeliveryFiles">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editAddCustomer.open(0,filter.customerId)">新建文件</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="文件名称">
            <el-input v-model.trim="filter.fileName" clearable/>
          </vm-search>
          <vm-search label="文件类型">
            <el-select v-model="filter.fileType" clearable placeholder="请选择">
              <el-option
                  v-for="item in fileType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="关键字">
            <el-input v-model.trim="filter.keyword" clearable/>
          </vm-search>
          <vm-search label="上传节点">
            <el-select v-model="filter.uploadNode" clearable placeholder="请选择">
              <el-option
                  v-for="item in upLoadNode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="打印类型">
            <el-select v-model="filter.printType" clearable placeholder="请选择">
              <el-option
                  v-for="item in printType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="fileName" align="center" label="文件名称"/>
      <el-table-column prop="fileType" align="center" label="文件类型">
        <template slot-scope="scope">
          <span>{{constant.fileType[scope.row.fileType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="keyword" align="center" label="关键字"/>
      <el-table-column prop="uploadNode" align="center" label="上传节点">
        <template slot-scope="scope">
          <span>{{constant.upLoadNode[scope.row.uploadNode]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="printerName" align="center" label="打印机名称"/>
      <el-table-column prop="printType" align="center" label="打印类型">
        <template slot-scope="scope">
          <span>{{constant.printType[scope.row.printType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="printQuantity" align="center" label="打印数量"/>
      <el-table-column label="操作" align="center" width="110px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editAddCustomer.open(scope.row.pkid,filter.customerId)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <span slot="footer">
      <el-button @click="close">关闭</el-button>
    </span>
    <customer-delivery-file-edit ref="editAddCustomer" @save-success="getList(1)"/>
  </el-dialog>
</template>


<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import CustomerDeliveryFileEdit from "@/views/information/Customer/CustomerDeliveryFileEdit";


  export default {
    name:"CustomerDeliveryFile",
    components: {CustomerDeliveryFileEdit, VmTable,VmSearch},
    data() {
      return {
        constant,
        fileType: constant.toSelect(constant.fileType),
        upLoadNode: constant.toSelect(constant.upLoadNode),
        printType: constant.toSelect(constant.printType),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        newPkids: [],
        filter: {
          customerId: "",
          fileName: "",
          fileType: "",
          keyword: "",
          uploadNode: "",
          printType: "",
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.filter.customerId = id;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      close() {
        this.$emit("save-success");
        this.dialogVisible = false;
        this.getList(1);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","customerDeliveryFiles",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
